import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

export default function GroupDialogSkeleton() {
  return (
    <Stack sx={{ px: 2 }} gap={2}>
      <Stack>
        <Skeleton variant="text" width={100} sx={{ mb: 0.5 }} />
        <Skeleton variant="rounded" width={180} height={40} />
      </Stack>
      <Skeleton variant="rounded" height={56} width="100%" />
      <Stack width="100%">
        <Stack flexDirection="row" alignItems="center" width="100%" gap={1}>
          <Skeleton variant="rounded" height={30} width="100%" />
          <Typography>@</Typography>
          <Skeleton variant="rounded" height={30} width="100%" />
        </Stack>
        <Skeleton variant="text" sx={{ mt: 0.5, ml: 2, width: '80%' }} />
      </Stack>
      <Skeleton variant="rounded" height={56} width="100%" sx={{ mt: 1 }} />
      <Stack spacing={2} sx={{ pb: 1, ml: 1.5, mt: 2 }}>
        <Skeleton variant="text" height={40} width="80%" />
        <Skeleton variant="text" height={40} width="80%" />
        <Skeleton variant="text" height={40} width="80%" />
      </Stack>

      <Stack mt={2}>
        <Skeleton variant="text" width="70%" sx={{ mb: 2 }} />
        <Stack direction="row" gap={4} ml={1.5}>
          <Skeleton variant="rectangular" width={120} height={24} />
          <Skeleton variant="rectangular" width={120} height={24} />
          <Skeleton variant="rectangular" width={120} height={24} />
        </Stack>
      </Stack>

      <Skeleton variant="rounded" height={50} width="100%" sx={{ mt: 1 }} />
    </Stack>
  );
}
